import {
    deleteTrafficLightDeviceDetails,
    fetchTrafficLightControllerDetails, addTrafficLightControllerDetails, updateTrafficLightDeviceDetails,
    updateTrafficLightSignalDetails
} from "../network/TrafficLightOverviewNetworkAPI";

export const TrafficLightOverviewReducer = (state,action) => {
    switch(action.type) {
        case "LOAD_DATA":
            fetchTrafficLightControllerDetails(action.data.dispatcher);
            return state;
        case "RECEIVE_DATA":
            return {...state, deviceInformation: action.data, loadingOverview: false};
        case "UPDATE_TRAFFIC_LIGHT_SIGNAL_DATA":
            updateTrafficLightSignalDetails(action.data.dispatcher, action.data.controllerDataIndex, action.data.trafficLightDataIndex, action.data.assetDetails);
            return state
        case "UPDATE_TRAFFIC_LIGHT_DEVICE_DATA":
            updateTrafficLightDeviceDetails(action.data.dispatcher, action.data.index, action.data.assetDetails);
            return state;
        case "ADD_CONTROLLER_DATA":
            addTrafficLightControllerDetails(action.data.dispatcher, action.data.assetDetails);
            return state;
        case "DELETE_CONTROLLER_DATA":
            deleteTrafficLightDeviceDetails(action.data.dispatcher, action.data.mac);
            return state;
        case "SHOW_UPDATE_RESPONSE_MODAL":
            return {...state, showResponseModal: action.data.modalState, modalMessageToDisplay: action.data.message};
        case "UPDATE_DATA":
            let updatedDeviceInformation = {...state.deviceInformation};
            updatedDeviceInformation.assetDetails[action.data.index] = {...action.data.assetDetails};
            return {...state, deviceInformation: updatedDeviceInformation};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/components/devicemanagement/trafficlightdevice/reducer/TrafficLightOverviewReducer.js